<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          2020 ©. Aquacultivos
        </div>
        <div class="col-sm-6">
          <div class="text-sm-right d-none d-sm-block">
              Todos Los derechos reservados
            <i class="mdi mdi-lapto text-danger"></i>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
// Vue
import { Component, Vue } from 'vue-property-decorator'

@Component({
    name: 'Footer'
})
export default class Footer extends Vue {}
</script>
